export const EMAIL_EVENTS = 'D-EMAIL_EVENTS';
export const MARKETING_EVENT_ACTIVITIES = 'D-MARKETING_EVENT_ACTIVITIES';
export const FORM_CONVERSIONS = 'D-FORM_CONVERSIONS';
export const CTA_ACTIVITIES = 'D-CTA_ACTIVITIES';